export const APP_NAME = 'APPAC_ADMIN'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'